export default __webpack_public_path__ + "img/reward_2-2-def04b2c.png";